module.exports = __webpack_public_path__ + "img/noData.e87a9590.png";